<template>
  <div class="zk-layout">
    <div class="layout-container">
      <slot></slot>
    </div>
    <div class="zk-footer-wrap" v-if="footerVisible">
      <zk-footer/>
    </div>
    <zk-back-top/>
  </div>
</template>

<script>
import ZkFooter from '../Footer'
import ZkBackTop from '../BackTop'

export default {
  name: "Layout",
  data () {
    return {}
  },
  mounted () {},
  props: {
    winPageData: {
      type: Object,
      default: () => ({})
    },
    footerVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
  },
  components: {
    ZkFooter,
    ZkBackTop
  }
}
</script>

<style lang="less">
@import '../../assets/css/common.less';

.zk-layout {
  display: flex;
  flex-direction: column;
  // min-width: 1216px;
  height: 100%;

  .layout-container {
    flex-grow: 1;
    position: relative;
    width: 100%;
  }

  .zk-footer-wrap {
    flex-shrink: 0;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?00f81018